import { Component, ViewChild,Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ReportsService } from "../../api/api/reports.service";
import { FacilitiesService, Facility } from "../../core/facilities/facilities.service";
import { MedicalRecordOptions } from "../../api/model/medicalRecordOptions";
import MedicalRecordEnum = MedicalRecordOptions.MedicalRecordEnum;
import { ReportResident } from "../../api/model/reportResident";
import { DateConversion, DateRange } from "../../shared/date/date-range";
import { DateTimeFormatter, LocalDate } from "@js-joda/core";
import SortOrderEnum = MedicalRecordOptions.SortOrderEnum;
import { AbstractDownloadFileContentComponent } from '../../shared/download-file-content/abstract-download-file-content.component';

@Component({
    /* Component for displaying a Report Row. */
    selector: 'my-medical-records-modal',
    styleUrls: ['medical-records-modal.component.scss'],
    templateUrl: 'medical-records-modal.component.html'
})
export class MedicalRecordsModalComponent extends AbstractDownloadFileContentComponent {

    @ViewChild('recordsModal', {static: false}) public recordsModal: ModalDirective;
    @Output()
    modalWasClicked:EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
    }

    screen: number = 0;
    searchText: string;
    hideSpinner: boolean=true;
    selectedNursingStation: boolean = false;
    selectedResidentCount: number = 0;
    isAllResidentsSelected: boolean = false;
    isAllNSSelected: boolean = false;

    filteredResidents: ReportResident[]=[];
    copyOfFilteredResidents: ReportResident[]=[];
    allPossibleResidents: ReportResident[]=[];
    effectiveDateRange: DateRange;
    selectedDates:DateRange;

    marOptions: MedicalRecordOptions = {};
    version: ModalVersion;
    title: string;
    sortOrderEnums: SortOrderEnum[];
    defaultResidentId: string;

    admissionStartDate: string;
    admissionEndDate: string;

    selectResident(){

        setTimeout(() => {
            this.selectedResidentCount = this.allPossibleResidents.filter(r => r.IsSelected).length;

            if (this.isAllResidentsSelected && this.selectedResidentCount === this.allPossibleResidents.length - 1) {
                this.allPossibleResidents.forEach(f => f.IsSelected = !f.IsSelected);
                this.isAllResidentsSelected = false;
                this.selectedResidentCount = this.allPossibleResidents.filter(r => r.IsSelected).length;
            }
            else {
                this.selectedResidentCount = this.allPossibleResidents.filter(r => r.IsSelected).length;
                this.isAllResidentsSelected = this.selectedResidentCount === this.allPossibleResidents.length;
            }
        });
    }

    selectAdmissionsDate(selectedDates: DateRange)
    {

        if(selectedDates){
            this.selectedDates=selectedDates;
            this.admissionStartDate = this.selectedDates.startDateTimeIsoString;
            this.admissionEndDate = this.selectedDates.endDateTimeIsoString;
        }
    }


    selectEffectiveDate(selectedDates: DateRange)
    {
        this.effectiveDateRange = selectedDates;
        this.dateRangeErrorText = null;
    }

    dateRangeErrorText: string;

    dateRangeError(error: string)
    {
        this.dateRangeErrorText = error;
    }

    getMaximumNumberOfDays(): number {
        /*
         * The error is only currently applicable to MAT/TAR reports
         * Therefore, we we will return null to indicate that we do not want to have max
        */
        if(this.marOptions.MedicalRecord == MedicalRecordEnum.POS){
            return null;
        }


        return 31;
    }

    searchResidents(value: string){
        if(value !== undefined && value !== null) {
            let lowerSearch = value.toLowerCase();

            this.filteredResidents = this.allPossibleResidents.filter(r => {
                let lowerCaseName = r.Name.toLowerCase();
                return lowerCaseName.indexOf(lowerSearch) >= 0;
            });
        }
    }

    setResidentsForSelectedStations(): void {
        let selectedNursingStations = this.marOptions.NursingStations.filter(x => x.IsSelected).map(ns => ns.Id);
        let residentsForStations = this.marOptions.Residents.filter(r => selectedNursingStations.indexOf(r.NursingStationId) >= 0);

        this.allPossibleResidents = residentsForStations.filter(r => {
            let startDate = null;
            let endDate = null;

            if(!r.AdmissionDate){
                // if they don't have an admit date, skip them.
                return false;
            }

            let admissionDate = LocalDate.parse(r.AdmissionDate, DateTimeFormatter.ofPattern("yyyy-MM-dd"));

            if(this.selectedDates.startDateTimeIsoString)
                startDate = LocalDate.parse(this.selectedDates.startDateTimeIsoString, DateTimeFormatter.ISO_LOCAL_DATE_TIME);

            if(this.selectedDates.endDateTimeIsoString)
                endDate = LocalDate.parse(this.selectedDates.endDateTimeIsoString, DateTimeFormatter.ISO_LOCAL_DATE_TIME);

            if(!startDate && !endDate){
                return true;
            }
            if(startDate && endDate){
                return admissionDate <= endDate && admissionDate >= startDate
            }else if (startDate){
                return admissionDate === startDate;
            }else {
                return admissionDate === endDate;
            }
        })
        this.filteredResidents = this.allPossibleResidents;
        this.searchResidents(this.searchText);
        this.selectResident();
    }

    selectAllNursingStations(){
        this.marOptions.NursingStations.forEach(ns => ns.IsSelected=true);
        this.selectNursingStation();
    }

    selectAllResidents(){
        this.filteredResidents.forEach(x => x.IsSelected=true);
        this.selectResident();
    }

    selectNursingStation(){
        setTimeout(()=>{
            let selectedNSCount = this.marOptions.NursingStations.filter(x => x.IsSelected).length;

            if(this.isAllNSSelected && selectedNSCount === this.marOptions.NursingStations.length - 1){
                this.marOptions.NursingStations.forEach(f => f.IsSelected = !f.IsSelected);
                this.isAllNSSelected = false;
            }else{
                this.selectedNursingStation =  selectedNSCount > 0;
                this.isAllNSSelected = this.marOptions.NursingStations.length === selectedNSCount;
            }
        });
    }

    protected setScreen(num: number) {
        //reset the previouse screen if coming from screen 3 to refresh all possible resident
        if(this.screen===3 && num===2)
        {
            this.marOptions.Residents = this.copyOfFilteredResidents;
            this.hideSpinner=true;
        }
        this.screen = num;
    }

    stepOne(){
        //Save options
        this.marOptions.StartDate = this.effectiveDateRange.startJsDateLocal;

        this.marOptions.EndDate = this.effectiveDateRange.endJsDateLocal;

        this.setScreen(2);
    }

    stepTwo(){
        // Need to calculate the available residents
        this.setResidentsForSelectedStations();

        this.setScreen(3);
    }

    showForResident(reportType: ModalVersion, residentId: string) {
        this.defaultResidentId = residentId;
        this.show(reportType);
    }

    show(reportType: ModalVersion) {
        this.version = reportType;

        // Explicit list to ensure order
        this.sortOrderEnums = [SortOrderEnum.NursingStationRoomBed, SortOrderEnum.NursingStationResidentName,
            SortOrderEnum.ResidentName, SortOrderEnum.RoomBed]
        if(reportType==='MAR/TAR'){
            this.title = 'View Medical Records';
            this.reportService.reportsGetMarTarOptions(this.facilityService.selectedAsOrgList[0]).subscribe((value: MedicalRecordOptions)=>{
                value.MedicalRecord = MedicalRecordEnum.MarTar;
                this.marOptions = value;

                // Default start date to today
                this.marOptions.StartDate = DateConversion.localDateToStartOfDayJsLocal(LocalDate.now());
                //keep a copy of the resident list
                this.copyOfFilteredResidents = this.marOptions.Residents;
                this.setInitialValues(value);
                this.selectAllMarOptions();

                this.recordsModal.show();

            });
        }else {
            this.title = 'Generate Physician Order Sheet';
            this.reportService.reportsGetPosOptions(this.facilityService.selectedAsOrgList[0]).subscribe((value: MedicalRecordOptions)=> {
                value.MedicalRecord = MedicalRecordEnum.POS;
                this.marOptions = value;

                // Default start date to the first day of the month
                this.marOptions.StartDate = DateConversion.localDateToStartOfDayJsLocal(LocalDate.now().withDayOfMonth(1));

                //keep a copy of the resident list
                this.copyOfFilteredResidents =this.marOptions.Residents;

                this.setInitialValues(value);

                this.recordsModal.show();
            });
        }
    }

    private setInitialValues(value: MedicalRecordOptions){
        // select all nursing stations by default
        this.selectAllNursingStations();

        // Default end dates to the last day of the month
        this.marOptions.EndDate = DateConversion.localDateToStartOfDayJsLocal(LocalDate.now().withDayOfMonth(1).plusMonths(1).minusDays(1));

        this.marOptions.ReportOptions.forEach(r => r.IsSelected=true);

        this.marOptions.sortOrder = SortOrderEnum.NursingStationRoomBed;

        if(this.defaultResidentId && this.defaultResidentId.length > 0){
            let resident = this.marOptions.Residents.find(r => r.ResidentId == this.defaultResidentId);
            resident.IsSelected = true;
            this.searchText = resident.Name;

            this.marOptions.NursingStations.forEach(ns => {
                if(resident.NursingStationId == ns.Id) {
                    ns.IsSelected = true;
                }else{
                    ns.IsSelected = false;
                }
            });
        }else{
            this.marOptions.Residents.forEach(r => r.IsSelected=true);
        }

        // Show the first screen; We have an empty screen 0 to ensure that initial state is set properly
        this.setScreen(1);
    }

    selectAllMarOptions(){
        let allSelected = this.marOptions.MarGroups.filter(x => x.IsSelected).length == this.marOptions.MarGroups.length;

        if(allSelected){
            this.marOptions.MarGroups.forEach(x => x.IsSelected = false);
        }else{
            this.marOptions.MarGroups.forEach(x => x.IsSelected = true);
        }
    }

    closeModal(){
        this.blankForm = false;
        this.screen = 0;
        this.searchText = '';
        this.defaultResidentId = null;
        this.recordsModal.hide();
        this.modalWasClicked.emit(false);
        this.ngOnDestroy();
    }

    generatePDF(){
        //this triggeer the visual cue that works is been done
        this.hideSpinner = false;
        // To ensure dates are in the right format, reset them here
        this.marOptions.StartDate = this.effectiveDateRange.startJsDateUTC;
        this.marOptions.EndDate = this.effectiveDateRange.endJsDateUTC;


        this.marOptions.NursingStations= this.marOptions.NursingStations.filter(x=>x.IsSelected);
        this.marOptions.Residents= this.filteredResidents.filter(x=>x.IsSelected);
        if(this.version === 'MAR/TAR'){
            this.reportService.reportsGetGeneratedMarTar(this.marOptions, this.facilityService.selectedAsOrgList[0])
                .subscribe((result) => {
                    this.downloadFile(result, 'MARTARForm.pdf');
                    this.hideSpinner = true;
                    this.closeModal();
                });
        } else {
            this.reportService.reportsGetGeneratedPos(this.marOptions, this.facilityService.selectedAsOrgList[0])
                .subscribe((result) => {
                    this.downloadFile(result, 'POSForm.pdf');
                    this.hideSpinner = true;
                    this.closeModal();
                });
        }

    }

    blankForm: boolean;

    selectBlank(){
        if(this.marOptions.MedicalRecord != MedicalRecordEnum.BlankForms) {
            this.marOptions.MedicalRecord = MedicalRecordEnum.BlankForms;
            this.blankForm = true;
        }
        else {
            this.marOptions.MedicalRecord = MedicalRecordEnum.MarTar;
            this.blankForm = false;
        }
    }

    getDisplayNameForEnum(sortOrder: SortOrderEnum): string{
        switch (sortOrder){
            case SortOrderEnum.NursingStationResidentName:
                return 'Nursing Station/Resident Name';
            case SortOrderEnum.NursingStationRoomBed:
                return 'Nursing Station/Room/Bed';
            case SortOrderEnum.ResidentName:
                return 'Resident Name';
            case SortOrderEnum.RoomBed:
                return 'Room/Bed';
            default:
                return sortOrder.toString();
        }
    }

    selectSortOrder(sortOrder: SortOrderEnum){
        setTimeout(()=>{
            this.marOptions.sortOrder=sortOrder;
        })
    }

    selectMarTar(){
        if(this.marOptions.MedicalRecord !== MedicalRecordEnum.BlankForms){
            if(this.marOptions.MedicalRecord == MedicalRecordEnum.MarTar){
                this.marOptions.MedicalRecord = MedicalRecordEnum.NoneSelected
            }else {
                this.marOptions.MedicalRecord = MedicalRecordEnum.MarTar;
            }
        }
    }

    selectMar(){
        if(this.marOptions.MedicalRecord == MedicalRecordEnum.MarTar){
            this.marOptions.MedicalRecord = MedicalRecordEnum.Tar
        }else if(this.marOptions.MedicalRecord == MedicalRecordEnum.Tar){
            this.marOptions.MedicalRecord = MedicalRecordEnum.MarTar;
        }else if(this.marOptions.MedicalRecord == MedicalRecordEnum.Mar){
            this.marOptions.MedicalRecord = MedicalRecordEnum.NoneSelected;
        }else {
            this.marOptions.MedicalRecord = MedicalRecordEnum.Mar;
        }
    }

    selectTar(){
        if(this.marOptions.MedicalRecord == MedicalRecordEnum.MarTar){
            this.marOptions.MedicalRecord = MedicalRecordEnum.Mar
        }else if(this.marOptions.MedicalRecord == MedicalRecordEnum.Mar){
            this.marOptions.MedicalRecord = MedicalRecordEnum.MarTar;
        }else if(this.marOptions.MedicalRecord == MedicalRecordEnum.Tar){
            this.marOptions.MedicalRecord = MedicalRecordEnum.NoneSelected;
        }else {
            this.marOptions.MedicalRecord = MedicalRecordEnum.Tar;
        }
    }

    tarValue = MedicalRecordEnum.Tar;
    marValue = MedicalRecordEnum.Mar;
    marTarValue = MedicalRecordEnum.MarTar;
    blankValue = MedicalRecordEnum.BlankForms;
    noneValue = MedicalRecordEnum.NoneSelected;
}

export type ModalVersion = "MAR/TAR"|"POS";